import { COMPOUNDS } from '../compounds';

export const WATER_BUCHWALD_HARTWIG_CONDITION_GROUPS = [
  // WBH_1_SET
  {
    catalyst: COMPOUNDS.PD_ACETATE,
    base: COMPOUNDS.CESIUM_CARBONATE,
    solvent: COMPOUNDS.DMAC_WATER,
    temperature: 60.0,
    time_in_h: 18.0,
  },
  // WBH_2_SET
  {
    catalyst: COMPOUNDS.PD_ACETATE,
    base: COMPOUNDS.POTASSIUM_PHOSPHATE,
    solvent: COMPOUNDS.DMAC_WATER,
    temperature: 80.0,
    time_in_h: 4.0,
  },
  // WBH_3_SET
  {
    catalyst: COMPOUNDS.PD_ACETATE,
    base: COMPOUNDS.TBUOK,
    solvent: COMPOUNDS.DMAC_WATER,
    temperature: 90.0,
    time_in_h: 0.5,
  },
  // WBH_4_SET
  {
    catalyst: COMPOUNDS.TBUBRETTPHOS_G3,
    base: COMPOUNDS.CESIUM_CARBONATE,
    solvent: COMPOUNDS.DMAC_WATER,
    temperature: 90.0,
    time_in_h: 0.5,
  },
  // WBH_5_SET
  {
    catalyst: COMPOUNDS.TBUBRETTPHOS_G3,
    base: COMPOUNDS.POTASSIUM_PHOSPHATE,
    solvent: COMPOUNDS.DMAC_WATER,
    temperature: 60.0,
    time_in_h: 18.0,
  },
  // WBH_6_SET
  {
    catalyst: COMPOUNDS.TBUBRETTPHOS_G3,
    base: COMPOUNDS.TBUOK,
    solvent: COMPOUNDS.DMAC_WATER,
    temperature: 80.0,
    time_in_h: 4.0,
  },
  // WBH_7_SET
  {
    catalyst: COMPOUNDS.TBUXPHOS_G3,
    base: COMPOUNDS.CESIUM_CARBONATE,
    solvent: COMPOUNDS.DMAC_WATER,
    temperature: 80.0,
    time_in_h: 4.0,
  },
  // WBH_8_SET
  {
    catalyst: COMPOUNDS.TBUXPHOS_G3,
    base: COMPOUNDS.POTASSIUM_PHOSPHATE,
    solvent: COMPOUNDS.DMAC_WATER,
    temperature: 90.0,
    time_in_h: 0.5,
  },
  // WBH_9_SET
  {
    catalyst: COMPOUNDS.TBUXPHOS_G3,
    base: COMPOUNDS.TBUOK,
    solvent: COMPOUNDS.DMAC_WATER,
    temperature: 60.0,
    time_in_h: 4.0,
  },
  // WBH_10_SET
  {
    catalyst: COMPOUNDS.TBUXPHOS_G3,
    base: COMPOUNDS.TBUOK,
    solvent: COMPOUNDS.DMAC_WATER,
    temperature: 60.0,
    time_in_h: 18.0,
  },
  // WBH_11_SET
  {
    catalyst: COMPOUNDS.PD_ACETATE,
    base: COMPOUNDS.TBUOK,
    solvent: COMPOUNDS.DMAC_WATER,
    temperature: 60.0,
    time_in_h: 18.0,
  },
  // WBH_12_SET
  {
    catalyst: COMPOUNDS.PD_ACETATE,
    base: COMPOUNDS.CESIUM_CARBONATE,
    solvent: COMPOUNDS.DMAC_WATER,
    temperature: 45.0,
    time_in_h: 18.0,
  },
  // WBH_13_SET
  {
    catalyst: COMPOUNDS.TBUBRETTPHOS_G3,
    base: COMPOUNDS.TBUOK,
    solvent: COMPOUNDS.DMAC_WATER,
    temperature: 60.0,
    time_in_h: 18.0,
  },
  // WBH_14_SET
  {
    catalyst: COMPOUNDS.TBUBRETTPHOS_G3,
    base: COMPOUNDS.CESIUM_CARBONATE,
    solvent: COMPOUNDS.DMAC_WATER,
    temperature: 60.0,
    time_in_h: 18.0,
  },
  // WBH_15_SET
  {
    catalyst: COMPOUNDS.PD_ACETATE,
    base: COMPOUNDS.POTASSIUM_PHOSPHATE,
    solvent: COMPOUNDS.DMAC_WATER,
    temperature: 60.0,
    time_in_h: 18.0,
  },
  // WBH_16_SET
  {
    catalyst: COMPOUNDS.TBUXPHOS_G3,
    base: COMPOUNDS.CESIUM_CARBONATE,
    solvent: COMPOUNDS.DMAC_WATER,
    temperature: 60.0,
    time_in_h: 18.0,
  },
];
